(function(){
  var KLAVIYO_LIST = 'KMTDtj';
  var DELAY_MS = 11000;
  var SCROLL_PCT = 0.30;
  var CAP_DAYS = 1;
  var KEY = 'sas_popup_seen';
  var NEVER_KEY = 'sas_popup_never';
  var ATTN_SEL = '#attentive_overlay, #attentive_creative, [id^="attentive"], [class*="attentive"], iframe[src*="attn.tv"], iframe[id*="attentive"]';
  var RELEASE_GAP_MS = 1200;
  var ATTN_WAIT_MS = 5000;

  var el = document.getElementById('sas-popup');
  if(!el) return;
  var card = el.querySelector('.sas-popup__card');
  var form = el.querySelector('.sas-popup__form');
  var field = el.querySelector('#sas-email');
  var submit = el.querySelector('[data-sas-submit]');
  var errEl = el.querySelector('[data-sas-error]');
  var stepCapture = el.querySelector('[data-sas-step="capture"]');
  var stepThanks = el.querySelector('[data-sas-step="thanks"]');
  var fallback = el.querySelector('[data-sas-fallback]');
  var landingBtn = el.querySelector('[data-sas-landing-btn]');
  var landingUrl = (el.getAttribute('data-sas-landing') || '').trim();
  var tab = document.getElementById('sas-tab');
  var optout = el.querySelector('[data-sas-optout]');
  var optoutNote = el.querySelector('[data-sas-optout-note]');
  var lastFocus = null;
  var pulseTab = false;
  var suppressed = false;
  var observer = null;

  /* ========== 9-22b INCOGNITO FREEZE FIX ==========
     ROOT CAUSE: Attentive's own sign-up unit auto-opens for every brand-new
     visitor (incognito = new every time) and locks page scroll with inline
     position:absolute + inset:0 + overflow:hidden on <html> and <body> until
     that unit closes. We hide Attentive's unit so it never stacks with ours,
     which left its lock on with nothing visible to close it: the page froze
     ~2s after landing. Returning visitors never saw it, because Attentive
     does not auto-open for people it already knows.
     FIX: close the hidden unit through Attentive's own API (__attentive.hide()
     releases its lock; __attentive.trigger() still opens it on demand for the
     phone step), then strip the lock ourselves if it is still on a moment later.
     Only acts while Attentive is suppressed, and only on Attentive's lock
     signature (position:absolute on BOTH <html> and <body>, or any page lock
     while its hidden unit is still mounted), so the menu, cart drawer and our
     own popup lock are left alone. */
  var styleObserver = null;
  var stripTimer = null;
  var lastAttnHide = 0;
  var attnHideCalls = 0;

  function attentiveLockOn(){
    var b = document.body;
    if(!b) return false;
    var hs = document.documentElement.style, bs = b.style;
    if(hs.position === 'absolute' && bs.position === 'absolute') return true;
    if(!document.getElementById('attentive_creative')) return false;
    return /fixed|absolute/.test(bs.position) || /fixed|absolute/.test(hs.position) || bs.overflow === 'hidden';
  }

  function stripAttentiveLock(){
    stripTimer = null;
    if(!suppressed || !attentiveLockOn()) return;
    var hs = document.documentElement.style, bs = document.body.style;
    var y = parseInt(bs.top, 10);
    var props = ['position','inset','top','right','bottom','left','height'];
    for(var i=0;i<props.length;i++){ hs.removeProperty(props[i]); bs.removeProperty(props[i]); }
    bs.removeProperty('overflow');
    if(el.classList.contains('is-open')){ hs.overflow = 'hidden'; } else { hs.removeProperty('overflow'); }
    if(y < 0){ try{ window.scrollTo(0, -y); }catch(e){} }
  }

  function neutralizeAttentive(){
    if(!suppressed) return;
    var mounted = !!document.getElementById('attentive_creative');
    var locked = attentiveLockOn();
    if(!mounted && !locked) return;
    var now = Date.now();
    if(attnHideCalls < 6 && now - lastAttnHide > 400){
      lastAttnHide = now;
      attnHideCalls++;
      try{ if(window.__attentive && typeof window.__attentive.hide === 'function'){ window.__attentive.hide(); } }catch(e){}
    }
    if(!stripTimer){ stripTimer = setTimeout(stripAttentiveLock, 600); }
  }

  function watchLock(){
    if(styleObserver || !window.MutationObserver || !document.body) return;
    styleObserver = new MutationObserver(neutralizeAttentive);
    try{
      styleObserver.observe(document.documentElement, {attributes:true, attributeFilter:['style']});
      styleObserver.observe(document.body, {attributes:true, attributeFilter:['style']});
    }catch(e){}
  }

  function unwatchLock(){
    if(styleObserver){ try{ styleObserver.disconnect(); }catch(e){} styleObserver = null; }
    if(stripTimer){ clearTimeout(stripTimer); stripTimer = null; }
  }
  /* ========== end 9-22b fix block ========== */

  function hideAttentiveNodes(){
    if(!suppressed) return;
    try{
      var nodes = document.querySelectorAll(ATTN_SEL);
      for(var i=0;i<nodes.length;i++){
        var n = nodes[i];
        if(n.tagName === 'SCRIPT') continue;
        n.style.setProperty('display','none','important');
        n.style.setProperty('visibility','hidden','important');
      }
    }catch(e){}
    neutralizeAttentive();
  }

  function suppressAttentive(){
    suppressed = true;
    document.documentElement.classList.add('sas-attn-off');
    hideAttentiveNodes();
    if(!observer && window.MutationObserver){
      observer = new MutationObserver(hideAttentiveNodes);
      try{ observer.observe(document.body, {childList:true, subtree:true}); }catch(e){}
    }
    watchLock();
  }

  function releaseAttentive(){
    suppressed = false;
    unwatchLock();
    document.documentElement.classList.remove('sas-attn-off');
    if(observer){ try{ observer.disconnect(); }catch(e){} observer = null; }
    try{
      var nodes = document.querySelectorAll(ATTN_SEL);
      for(var i=0;i<nodes.length;i++){
        nodes[i].style.removeProperty('display');
        nodes[i].style.removeProperty('visibility');
      }
    }catch(e){}
  }

  function attentiveVisible(){
    try{
      var nodes = document.querySelectorAll(ATTN_SEL);
      for(var i=0;i<nodes.length;i++){
        var n = nodes[i];
        if(n.tagName === 'SCRIPT') continue;
        var r = n.getBoundingClientRect();
        if(r.width > 180 && r.height > 180) return true;
      }
    }catch(e){}
    return false;
  }

  function attentiveMounted(){
    try{ return !!document.getElementById('attentive_creative'); }catch(e){ return false; }
  }

  function waitForAttentive(maxMs, done){
    var t0 = Date.now();
    (function poll(){
      if(attentiveVisible()){ done(true); return; }
      if(Date.now() - t0 >= maxMs){ done(false); return; }
      setTimeout(poll, 250);
    })();
  }

  function showFallback(btn){
    if(landingBtn && landingUrl){
      landingBtn.setAttribute('href', landingUrl);
      landingBtn.hidden = false;
    }
    if(fallback) fallback.hidden = false;
    if(btn){
      btn.style.display = 'none';
      btn.disabled = false;
      btn.textContent = 'Text me 15% off';
    }
    suppressAttentive();
    try{ card.scrollTop = 0; }catch(e){}
  }

  function capped(){
    try{
      var v = localStorage.getItem(KEY);
      return v && (Date.now() - parseInt(v,10)) < CAP_DAYS*864e5;
    }catch(e){ return false; }
  }
  function markSeen(){ try{ localStorage.setItem(KEY, String(Date.now())); }catch(e){} }

  function neverAuto(){
    try{ return localStorage.getItem(NEVER_KEY) === '1'; }catch(e){ return false; }
  }

  function doPulse(){
    if(!tab) return;
    tab.classList.remove('sas-tab--pulse');
    void tab.offsetWidth;
    tab.classList.add('sas-tab--pulse');
    setTimeout(function(){ tab.classList.remove('sas-tab--pulse'); }, 1400);
  }

  function showTab(){ if(tab){ tab.hidden = false; } }
  function hideTab(){ if(tab){ tab.hidden = true; } }

  function open(force){
    if(el.classList.contains('is-open')) return;
    if(!force){
      if(neverAuto()){ showTab(); return; }
      if(capped()){ showTab(); return; }
    }
    reveal();
  }

  function reveal(){
    if(el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    suppressAttentive();
    hideTab();
    setTimeout(function(){ try{ field.focus(); }catch(e){} }, 80);
    markSeen();
  }

  function close(keepAttentive){
    el.classList.remove('is-open');
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if(!keepAttentive){ suppressAttentive(); }
    showTab();
    if(pulseTab){ pulseTab = false; doPulse(); }
    try{ if(lastFocus && lastFocus.focus) lastFocus.focus(); }catch(e){}
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-sas-open]')){ e.preventDefault(); open(true); return; }
    if(!el.contains(e.target)) return;
    if(e.target.closest('[data-sas-close]')){ e.preventDefault(); close(); return; }
    if(e.target.closest('[data-sas-attentive]')){
      e.preventDefault();
      var btn = e.target.closest('[data-sas-attentive]');
      if(btn.disabled) return;
      if(landingUrl){
        try{ window.open(landingUrl, '_blank', 'noopener'); }catch(err0){ location.href = landingUrl; }
        close();
        return;
      }
      if(!window.__attentive){ showFallback(btn); return; }
      btn.disabled = true;
      btn.textContent = 'Opening text sign-up...';
      releaseAttentive();
      setTimeout(function(){
        var fired = false;
        try{
          if(window.__attentive && typeof __attentive.trigger === 'function'){
            var p = __attentive.trigger();
            fired = true;
            if(p && typeof p['catch'] === 'function'){ p['catch'](function(){}); }
          }
        }catch(err){}
        if(!fired){
          try{ if(window.__attentive && typeof __attentive.show === 'function'){ __attentive.show(); fired = true; } }catch(err2){}
        }
        if(!fired){ showFallback(btn); return; }
        waitForAttentive(ATTN_WAIT_MS, function(ok){
          if(ok){
            close(true);
            btn.disabled = false;
            btn.textContent = 'Text me 15% off';
          } else {
            showFallback(btn);
          }
        });
      }, RELEASE_GAP_MS);
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if(!el.classList.contains('is-open')) return;
    if(e.key === 'Escape'){ close(); return; }
    if(e.key === 'Tab'){
      var f = card.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
      var vis = [].filter.call(f, function(n){ return n.offsetParent !== null; });
      if(!vis.length) return;
      var first = vis[0], last = vis[vis.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });

  /* ========== 10-13 SIGNUP CHECK ==========
     Klaviyo answers HTTP 200 even when it turns a signup down
     ({"success": false, "errors": [...]}), and a blocked or dropped request
     never reaches it at all. The old code showed "Your 10% code is on its way"
     either way. Now the thanks step shows only when Klaviyo says success:true;
     otherwise the visitor sees a try-again message and stays on the form. */
  var ERR_INVALID = errEl ? errEl.textContent : 'Please enter a valid email address.';
  var ERR_FAILED = "That didn't go through. Please try again.";
  var SUBMIT_TIMEOUT_MS = 10000;

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = (field.value || '').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)){ errEl.textContent = ERR_INVALID; errEl.hidden = false; field.focus(); return; }
    errEl.hidden = true;
    errEl.textContent = ERR_INVALID;
    submit.disabled = true;
    submit.textContent = 'Sending...';

    var body = new URLSearchParams();
    body.append('g', KLAVIYO_LIST);
    body.append('email', email);
    body.append('$fields', 'email');

    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function(){ try{ ctrl.abort(); }catch(x){} }, SUBMIT_TIMEOUT_MS) : null;
    var opts = {
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded','Cache-Control':'no-cache'},
      body: body.toString()
    };
    if(ctrl) opts.signal = ctrl.signal;

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', opts).then(function(res){
      return res.json().then(function(j){ return !!(res.ok && j && j.success === true); }, function(){ return false; });
    }).catch(function(){ return false; }).then(function(ok){
      if(timer) clearTimeout(timer);
      submit.disabled = false;
      submit.textContent = 'Send my code';
      if(!ok){
        errEl.textContent = ERR_FAILED;
        errEl.hidden = false;
        try{ if(window.dataLayer){ dataLayer.push({event:'sas_popup_email_failed'}); } }catch(e){}
        return;
      }
      try{ if(window.klaviyo && klaviyo.identify){ klaviyo.identify({'$email': email}); } }catch(e){}
      try{ if(window.attentive && attentive.analytics && attentive.analytics.identify){ attentive.analytics.identify({ email: email }); } }catch(e){}
      try{ if(window.dataLayer){ dataLayer.push({event:'sas_popup_email_capture'}); } }catch(e){}
      stepCapture.hidden = true;
      stepThanks.hidden = false;
      try{ card.scrollTop = 0; }catch(e){}
    });
  });
  /* ========== end 10-13 signup check ========== */

  if(optout){
    optout.addEventListener('change', function(){
      if(optout.checked){
        try{ localStorage.setItem(NEVER_KEY, '1'); }catch(e){}
        if(optoutNote) optoutNote.hidden = false;
        pulseTab = true;
      } else {
        try{ localStorage.removeItem(NEVER_KEY); }catch(e){}
        if(optoutNote) optoutNote.hidden = true;
        pulseTab = false;
      }
    });
    if(neverAuto()){
      optout.checked = true;
      if(optoutNote) optoutNote.hidden = false;
    }
  }

  setTimeout(function(){ open(false); }, DELAY_MS);
  window.addEventListener('scroll', function onScroll(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if(h > 0 && (window.scrollY / h) >= SCROLL_PCT){ window.removeEventListener('scroll', onScroll); open(false); }
  }, {passive:true});

  suppressAttentive();
  if(capped() || neverAuto()) showTab();
})();
